module.exports = __webpack_public_path__ + "static/sport/end-title.8cedf0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/end-title.png
// module id = WoHD
// module chunks = 0